/**
 * invoice_id -> current status, read off each ledger row's `applied_invoice`
 * FK embed. The ONE implementation: `useCustomerCreditsData` re-exports it as
 * `buildInvoiceStatusMap`, and a lean reader such as useCustomerCreditSummary
 * imports it directly without pulling in that hook's session cache + auth
 * tree. Rows with no invoice_id or an inaccessible /
 * deleted invoice (embed null) contribute nothing.
 */
export function invoiceStatusMapFromLedger(entries) {
  const map = {};
  for (const entry of Array.isArray(entries) ? entries : []) {
    const status = entry?.applied_invoice?.status;
    if (entry?.invoice_id && status) map[entry.invoice_id] = status;
  }
  return map;
}
